/* eslint-disable import/extensions */
import React, { useState } from 'react';
import { usePathname } from 'next/navigation';
import { Badge, Button, Form, InputGroup, } from 'react-bootstrap';
import { FaCheck, FaQuestion, FaXmark, } from 'react-icons/fa6';
import { help, http, layout, messages, store, } from '@/helpers/index';

export default function ToolbarCrmComponent() {
  const pathname = usePathname();
  const [email, setEmail] = useState();
  const [customer, setCustomer] = useState(store.customer.get());

  const handleOnChange = ({ target }) => {
    setEmail(target.value);
  };

  const handleCustomerCustomer = (e) => {
    e.preventDefault();
    if (!email) {
      layout.focus('customerEmail');
      return;
    }
    layout.loading(true);
    http.get(`/manager/users/email/${email}`, (result, resultError) => {
      layout.loading(false);
      if (resultError) {
        messages.error(resultError.message, false, true);
        return;
      }
      store.customer.set(result);
      setCustomer(result);
      if (window?.crm) {
        window.crm.toolbar.manager.load();
      }
    });
  };

  const handleCustomerRemover = () => {
    store.customer.remove();
    setCustomer();
    layout.focus('customerEmail');
    if (window?.crm) {
      window.crm.toolbar.manager.load();
    }
  };

  return (
    <div className="btn-toolbar mb-2 mb-md-0">
      {/* <div className="btn-group me-2">
        <Button type="button" variant="secondary" size="sm" className="btn-outline-secondary">Compartilhar</Button>
        <Button type="button" variant="secondary" size="sm" className="btn-outline-secondary">Exportar</Button>
      </div>
      <Button type="button" variant="secondary" size="sm" className="btn-outline-secondary dropdown-toggle">
        <span data-feather="calendar" />
        Esta semana
      </Button> */}
      {!customer && (
        <Form onSubmit={handleCustomerCustomer}>
          <Form.Group>
            <InputGroup size="sm">
              <Form.Control
                type="email"
                name="email"
                id="customerEmail"
                aria-describedby="emailHelp"
                placeholder="Digite o E-mail do Usuário"
                size="sm"
                required
                value={email}
                onChange={handleOnChange}
              />
              <Button type="submit" size="sm" title="Selecionar Usuário"><FaCheck /></Button>
            </InputGroup>
          </Form.Group>
        </Form>
      )}
      {customer && (
        <div>
          <Badge bg="dark" className="customer-selected">{customer.name}</Badge>
          <Badge bg="light" size="sm" className="text-dark ms-1 customer-selected cursor-pointer" onClick={handleCustomerRemover} title="Desselecionar Usuário"><FaXmark /></Badge>
        </div>
      )}
      <Button type="button" variant="secondary" size="sm" className="shadow-sm ms-1" onClick={() => { help.show(pathname); }} title="Abrir barra de Ajuda">
        <FaQuestion />
        Ajuda
      </Button>
    </div>
  );
}
